<template>
  <div class="flightoffer">
    <div class="flightoffer--pad">
      <div class="flightoffer--wrapper">
        <div class="flightoffer--itineraries">
          <div v-if="is_best.length > 0" class="flightoffer--picks">
            <best-pick-pill v-for="value in is_best" :key="value" :value="value" />
          </div>
          <div
            v-for="(itinerary, itinerary_index) in flight_offer.itineraries"
            :key="`${_uid}--${itinerary_index}`"
            class="flightoffer--flex flightoffer--flex--item"
          >
            <div class="flightoffer--company">
              <!-- logo -->
              <img
                :src="`https://static.vadobay.com/airlines-logos/200x100/${carrier_iata(
                  itinerary
                )}.png`"
                :alt="carrier_iata(itinerary)"
              />
              <!-- company name -->
              <span class="small text-muted d-lg-block d-xl-block d-none">
                <span v-if="dictionaries.carriers">
                  {{ dictionaries.carriers[carrier_iata(itinerary)] }}
                  {{ carrier_iata(itinerary) }}
                </span>
                <span v-else>
                  {{ carrier }}
                </span>
              </span>
            </div>
            <div
              class="flightoffer--itinerary"
              v-b-toggle="details_ref_id"
              @click="() => show_details()"
            >
              <div class="flightoffer--flex flex-grow-1 gap-10px">
                <div class="flightoffer__flight-pad-path-wrapper">
                  <flight-pad-endpoint
                    :info="itinerary.segments[0].departure"
                    alignment="end"
                    highlight_time
                  />
                  <flight-pad-horizontal-path :itinerary="itinerary">
                    <template #duration> </template>
                  </flight-pad-horizontal-path>
                  <flight-pad-endpoint
                    :info="itinerary.segments[itinerary.segments.length - 1].arrival"
                    :delta="get_itinerary_delta(itinerary)"
                    alignment="start"
                    highlight_time
                  />
                </div>
                <div class="flightoffer--bags">
                  <flight-pad-bags
                    :flight_offer="flight_offer"
                    :itinerary_index="itinerary_index"
                  />
                </div>
                <div class="flightoffer--toggle">
                  <div v-html="chevron_right"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flightoffer--prices">
          <flight-pad-price-button :flight_offer="flight_offer" />
        </div>
        <flight-pad-details-modal
          :ref="details_ref_id"
          :wrapper_id="details_ref_id"
          :flight_offer="flight_offer"
          :selectable="selectable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { IdState } from 'vue-virtual-scroller';
import { chevron_right } from '@/components/svg/chevrons';
import { get_markup } from '@/flight-offer';
import { getSeatsForSegment } from '../../../utilities/seat-map';
import FlightPadEndpoint from '@/components/blocks/flight-pad/flight-pad-endpoint.vue';
import FlightPadBags from '@/components/blocks/flight-pad/flight-pad-bags.vue';
import FlightPadPriceButton from '@/components/blocks/flight-pad/flight-pad-price-button.vue';
import FlightPadDetailsModal from '@/components/blocks/flight-pad/flight-pad-details/flight-pad-details-modal.vue';
import FlightPadHorizontalPath from '@/components/blocks/flight-pad/flight-pad-horizontal-path.vue';
import { carrier_iata, get_day_delta, get_itinerary_delta } from './utilities';
import BestPickPill from './best-picks/best-pick-pill.vue';

export default {
  name: 'flightoffer',
  components: {
    //'included-checked-bags': IncludedCheckedBags,
    'flight-pad-endpoint': FlightPadEndpoint,
    'flight-pad-bags': FlightPadBags,
    'flight-pad-horizontal-path': FlightPadHorizontalPath,
    'flight-pad-price-button': FlightPadPriceButton,
    'flight-pad-details-modal': FlightPadDetailsModal,
    'best-pick-pill': BestPickPill,
  },
  props: {
    flight_offer: Object,
    flight_offer_index: Number,
    canShowSeats: {
      type: Boolean,
      default: false,
    },
    travelersDetails: {
      type: Array,
      default: () => [],
    },
    is_best: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    dictionaries() {
      return this.$store.state.liveflight.results.dictionaries;
    },
  },
  created() {
    this.get_markup = get_markup;
    this.chevron_right = chevron_right;
    this.travelers = this.travelersDetails.reduce(
      (map, traveler) => ({
        ...map,
        [traveler.id]: {
          ...traveler,
          fullName: traveler.name.firstName + ' ' + traveler.name.lastName,
        },
      }),
      {}
    );
  },
  mounted() {},
  data() {
    // attenzione: poiché è utilizzato all'interno di un virtual scroller, le data() sono tutte condivise tra gli items scrollabili
    // quindi vanno evitate oppure contestualizzate tramite opportuno mixin che sostituisce l'oggetto di data() con un altro scoped nell'oggetto
    // docs: https://github.com/Akryum/vue-virtual-scroller#idstate
    return {
      travelers: {},
      details_ref_id: `${this.$router.currentRoute.name}:flight-pad-details:${this.flight_offer.id}:${this.flight_offer_index}`,
    };
  },
  mixins: [
    IdState({
      // You can customize this
      idProp: (vm) => vm.flight_offer.id,
    }),
  ],
  // This replaces data () { ... }
  idState() {
    return {
      departure: {},
      arrival: {},
    };
  },
  methods: {
    getSeatsForSegment,
    carrier_iata,
    get_day_delta,
    get_itinerary_delta,
    scroll_position() {
      let el = document.getElementById('flight-' + this.flight_offer_index);
      let node = el.closest('.flight--pad-' + this.flight_offer_index);

      if (node == null) return;

      let parent = node.parentNode;

      parent.classList.toggle('b-popover');
      el.scrollIntoView();
    },
    show_details() {
      try {
        if (this.$refs && this.$refs[this.details_ref_id]) {
          this.$refs[this.details_ref_id].show_modal();
        }
      } catch (e) {
        this.log('flight-pad.show_modal');
        this.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
$cell-padding: $grid-gutter-width/4 $grid-gutter-width/2;

.flightoffer {
  $this: &;
  border-bottom: $grid-gutter-width/2 solid transparent;
  &--company {
    padding: $grid-gutter-width;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: $grid-gutter-width / 10;

    width: 20%;
    max-width: 280px;
    padding: $cell-padding;
    @include media-breakpoint-down(xs) {
      width: 100%;
      max-width: 100%;
      padding: 0;
      margin: 0;
    }

    overflow: hidden;
    span {
      text-wrap-mode: nowrap;
      text-overflow: ellipsis;
    }

    img {
      width: min(90px, 32vw);
    }
  }

  &--wrapper {
    @extend .panel !optional;
    @include font-primary-regular;
    padding: 10px;
    color: $text;
    font-size: $font-size-base;
    display: flex;
    width: 100%;

    @include media-breakpoint-down(md) {
      padding: $grid-gutter-width / 2;
      flex-direction: column;
    }
  }
  &--itineraries {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    border-right: 1px solid $light-gray;

    & > div:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }
    @include media-breakpoint-down(md) {
      border-right: 0px;
      & > div {
        padding-bottom: $grid-gutter-width / 3;
        border-bottom: 1px solid $light-gray;
      }
    }
  }
  &--itinerary-recap {
    padding: $cell-padding;
    margin-top: $grid-gutter-width/4;

    * {
      @include font-primary-regular;
    }

    &-title {
      font-size: $h5-font-size;

      @include media-breakpoint-up(lg) {
        font-size: $h3-font-size;
      }
    }
  }
  &--itinerary {
    flex: 1;
    &:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }
    display: flex;
    flex-wrap: wrap;
  }

  &--flex {
    display: flex;

    &--item {
      &:first-child {
        padding-bottom: 5px;
      }

      &:last-child {
        padding-top: 5px;
      }
    }

    @include media-breakpoint-down(md) {
      & > * {
        width: 100%;
      }
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &--toggle {
    width: 50px;
    //height:127px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 12px;
      height: 12px;
    }
    [role='button'],
    & > div {
      transition: $transition-base;
    }
    @at-root #{$this}--itinerary.not-collapsed & > div {
      transform: rotate(90deg);
    }

    @include media-breakpoint-down(md) {
      transform: rotate(90deg);
      @at-root #{$this}--itinerary.not-collapsed & > div {
        transform: rotate(180deg);
      }
    }
  }
  &__flight-pad-path-wrapper {
    width: 80%; //66%;
    display: flex;
    & > :first-child {
      width: 15%;
    }
    & > :last-child {
      width: 15%;
    }
    @include media-breakpoint-down(md) {
      width: 100% !important;
    }
  }
  &--bags {
    width: calc(20% - 50px); //calc(34% - 50px);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    div {
      display: flex;
      gap: 5px;
      align-items: flex-end;
    }

    @include media-breakpoint-down(md) {
      display: none;
    }
  }
  &--prices {
    display: flex;
    flex-direction: column;

    width: 20%;
    max-width: 280px;

    @include media-breakpoint-down(md) {
      width: 100%;
      max-width: 100%;
    }
  }
  &--picks {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-right: 10px;
    border-bottom: 0 !important;
    @include media-breakpoint-down(md) {
      padding-right: 0;
    }
  }
}

//nascondere elementi in altre viste:
.detail,
.checkout,
.confirm {
  .flightoffer--prices {
    display: none !important;
  }
  .flightoffer--wrapper > div:not(:last-child) {
    border: 0 !important;
  }
}
</style>
